export default __webpack_public_path__ + "static/media/filter.05ec9204.svg";